<div class="change-log" *ngIf="changeLog">
  <div
      class="change-log__entry"
      [ngClass]="[change.markerNew ? 'icon-dot' : '', change.type, change.userAction ? 'user-action' : '']"
      *ngFor="let change of changeLog">
    {{ change.label }}
  </div>
</div>
